import './styles.scss';
import { DisposalSet, onReadyEach } from '@neptune/cx/utils';
import { initAttachmentField } from './attachments';
import { initBoardAnchor } from './board-anchor';
import { initReplyComposer, REPLY_COMPOSER_SELECTOR } from './composers';
import { initDeepLink } from './deep-link';
import { initLegacyLinks } from './legacy-links';
import { initRichTextField } from './rich-text';
import { initTagFilter } from './tag-filter';

const gc = new DisposalSet();

// Registered ahead of the deep-link handling below, which replaces the fragment once it resolves
// a target. It acts only when the board is actually on the page.
initLegacyLinks();

// A reply composer's fields are left to initReplyComposer, which starts them when it opens.
onReadyEach<HTMLElement>('[data-chroa-rich-text]', (fieldEl) => {
    if (!fieldEl.closest(REPLY_COMPOSER_SELECTOR)) initRichTextField(fieldEl, gc);
});

onReadyEach<HTMLElement>('[data-chroa-attachments]', (fieldEl) => {
    if (!fieldEl.closest(REPLY_COMPOSER_SELECTOR)) initAttachmentField(fieldEl, gc);
});

// Ahead of the deep-link handling below, which puts the caret in the composer left open.
onReadyEach<HTMLDetailsElement>(REPLY_COMPOSER_SELECTOR, (composerEl) => {
    initReplyComposer(composerEl, gc);
});

onReadyEach<HTMLDetailsElement>('[data-chroa-tag-filter]', (panel) => {
    initTagFilter(panel, gc);
});

// Scoped to the widget root rather than the target attribute: a message named only by the URL
// fragment leaves no target attribute on the root to select on. initBoardAnchor goes first because
// it marks an anchor it lands on, so that initDeepLink does not scroll there again.
onReadyEach<HTMLElement>('.chroa-discussion-board', (root) => {
    initBoardAnchor(root, gc);
    initDeepLink(root, gc);
});

if (import.meta.hot) {
    import.meta.hot.accept();
    import.meta.hot.dispose(() => gc.disposeAll());
}
